import { Lightbulb } from 'phosphor-react';

function NeedTimeFileContractorReport(): JSX.Element {
  return (
    <div className="mt-8 bg-gray-100 rounded px-6 py-8">
      <div className="flex">
        <div className="pr-4">
          <Lightbulb size={20} />
        </div>
        <div className="flex-1">
          <div className="w-3/4">
            <div className="text-gray-900 font-medium">
              Need more time to file your Labor Contractor Report?
            </div>
            <div className="text-gray-700 mt-2">
              Follow these steps to file an Enforcement Deferral Request by May 10th 2023, extending
              the deadline to Monday, July 10th 2023:*
            </div>
            <ul className="text-gray-900 text-base leading-8 list-decimal w-4/5 mt-4 ml-5">
              <li>
                Log into the&nbsp;
                <a
                  href="https://pdr.calcivilrights.ca.gov/s/"
                  className="btn-link"
                  target="_blank"
                  rel="noreferrer">
                  CA Pay Data Reporting Portal
                </a>
                &nbsp;
              </li>
              <li>
                See the Enforcement Deferral Request section at the bottom of the page and continue
                to “Click here to request a deferral”
              </li>
              <li>Click “Begin”</li>
              <li>Fill out and submit your request</li>
            </ul>
            <div className="text-gray-700 text-sm mt-4">
              *Enforcement Deferral Requests apply to Labor Contractor Reports only, NOT Payroll
              Employee Reports.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NeedTimeFileContractorReport;
